"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.InterviewContext = exports.initialState = void 0;
exports.interviewReducer = interviewReducer;
/*
 * Copyright 2022, Polytechnique Montreal and contributors
 *
 * This file is licensed under the MIT License.
 * License text available at https://opensource.org/licenses/MIT
 */
const get_1 = __importDefault(require("lodash/get"));
const LodashExtensions_1 = require("chaire-lib-common/lib/utils/LodashExtensions");
const React = __importStar(require("react"));
const application_config_1 = __importDefault(require("../config/application.config"));
const queryDataToResponse = (queryData, stateResponse) => {
    const alphaNumRegex = /^[a-z0-9-_]+/i;
    const response = {};
    application_config_1.default.allowedUrlFields.forEach((field) => {
        const value = queryData.get(field);
        if (!(0, LodashExtensions_1._isBlank)(value)) {
            const alphaNumSource = value.match(alphaNumRegex);
            if (alphaNumSource && (0, get_1.default)(stateResponse, field) !== alphaNumSource[0])
                response[field] = alphaNumSource[0];
        }
    });
    return Object.keys(response).length !== 0 ? Object.assign({}, stateResponse, response) : stateResponse;
};
function interviewReducer(state, action) {
    switch (action.type) {
        case 'createNew':
            return {
                status: 'creating',
                response: queryDataToResponse(action.queryData, state.response),
                username: action.username
            };
        case 'list':
            return Object.assign(Object.assign({}, state), { status: 'list' });
        case 'success':
            return { status: 'success', response: state.response, interviewUuid: action.interviewUuid };
        case 'update_response':
            return Object.assign(Object.assign({}, state), { status: 'list', response: action.response });
        case 'enter':
            return {
                status: 'entering',
                response: queryDataToResponse(action.queryData, state.response)
            };
    }
}
exports.initialState = { status: 'list', response: {} };
exports.InterviewContext = React.createContext({
    state: exports.initialState,
    dispatch: () => {
        /* To be replaced with actual dispatch */
    }
});
//# sourceMappingURL=InterviewContext.js.map